import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3ebb5b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "importModal__stepOne"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "下载模板", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "上传文件", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "importModal__upload" }
const _hoisted_9 = ["disabled", "value"]
const _hoisted_10 = {
  key: 1,
  class: "importModal__stepTwo"
}
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "text-error" }
const _hoisted_13 = { class: "text-primary" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件上传失败，请稍后重试。", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "文件已上传成功，系统正在处理......", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "稍后可在【系统管理】-【操作日志】-【批量处理记录】中查看处理结果。", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "导入中, 请稍候", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    class: _normalizeClass(["importModal", {noClose: _ctx.uploading}]),
    title: _ctx.title,
    width: 650,
    footer: null,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      (_ctx.step === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              (_ctx.importTitle === 1 || _ctx.importTitle === 3)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "请先下载文件模板，并按照模板格式填写车辆信息。"))
                : (_openBlock(), _createElementBlock("p", _hoisted_4, "请先下载车辆额度调整模板，并按照模板填写额度调整信息。")),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDownload(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 下载模版 ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              (_ctx.importTitle === 1 || _ctx.importTitle === 3)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "请上传填写好的车辆信息文件。"))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, "请上传填写好的车辆额度调整文件。")),
              _withDirectives(_createElementVNode("div", _hoisted_8, [
                _createVNode(_component_a_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode("上传文件")
                  ]),
                  _: 1
                }),
                _createElementVNode("input", {
                  type: "file",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                  disabled: _ctx.uploading,
                  value: _ctx.formData.file,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpload($event)))
                }, null, 40, _hoisted_9)
              ], 512), [
                [_vShow, !_ctx.uploadComplete]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (!_ctx.uploading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h2", null, "导入" + _toDisplayString(_ctx.batchCode ? '成功' : '失败'), 1),
                  (_ctx.importTitle === 1 || _ctx.importTitle === 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.uploadRes.fail)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("p", null, [
                                _createTextVNode("结果: 成功导入 ("),
                                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.uploadRes.success), 1),
                                _createTextVNode(") 条。失败 ("),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.uploadRes.fail), 1),
                                _createTextVNode(") 条。下载导入结果文件查看失败原因，请修改数据后重新导入。")
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownload(1, _ctx.uploadRes.importFailKey)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("下载导入结果文件")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  style: {"margin-left":"10px"},
                                  onClick: _ctx.onComfirm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("关闭")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("p", null, [
                                _createTextVNode("结果: 操作成功，共成功导入 ("),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.uploadRes.success), 1),
                                _createTextVNode(") 条。")
                              ]),
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _ctx.onComfirm
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("关闭")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.batchCode)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_14,
                              _createElementVNode("div", null, [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: _ctx.show
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("重新上传")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  style: {"margin-left":"10px"},
                                  onClick: _ctx.onComfirm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("关闭")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_15,
                              _hoisted_16,
                              _createElementVNode("div", null, [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: _ctx.onComfirm
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("关闭")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  style: {"margin-left":"10px"},
                                  onClick: _ctx.viewResults
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("查看处理结果")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ], 64))
                      ], 64))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_spin),
                  _hoisted_17
                ], 64))
          ]))
    ]),
    _: 1
  }, 8, ["visible", "class", "title", "onCancel"]))
}